export const PRE_AUDIT_DEMO_BASE_ROUTE = "/PreAudit-Demo";
export const PRE_AUDIT_DEMO_SESSION_KEY = "andus:pre-audit:demo:account:v1";

export const PRE_AUDIT_DEMO_ACCOUNTS = Object.freeze([
  Object.freeze({ email: "preaudit.admin.demo@andus.test", role: "admin", label: "Management" }),
  Object.freeze({ email: "preaudit.reviewer.demo@andus.test", role: "reviewer", label: "Reviewer" }),
  Object.freeze({ email: "preaudit.supplier.demo@andus.test", role: "supplier", label: "Supplier" }),
]);

export function preAuditDemoAccountForEmail(value) {
  const email = String(value || "").trim().toLowerCase();
  return PRE_AUDIT_DEMO_ACCOUNTS.find((account) => account.email === email) || null;
}
